import { ServiceConnectionRefModel } from '../FlowDesigner/Models/ServiceConnectionModel';
import { ServiceConnectionModel } from '../../api/api';
import ServiceConnectionDialog from './ServiceConnectionDialog';

type EditServiceConnectionDialogProps = {
	open: boolean;
	setOpen: (open: boolean) => void;
	onSuccess?: (value: ServiceConnectionRefModel) => void;
	serviceConnection: ServiceConnectionModel;
};

export default function EditServiceConnectionDialog({ open, setOpen, onSuccess, serviceConnection }: EditServiceConnectionDialogProps) {
	return <ServiceConnectionDialog open={open} setOpen={setOpen} onSuccess={onSuccess} mode="edit" serviceConnectionToEdit={serviceConnection} />;
}
